<app-header></app-header>
<app-loading-indicator></app-loading-indicator>
<router-outlet></router-outlet>
